export enum ScheduledReportRunStatusType {
    UNKNOWN,
    NA,
    SUCCESS,
    FAILED,
    WARNINGS,
    RUNNING,
}
